// src/components/DevAuthButton.jsx
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function DevAuthButton() {
  // ✅ hooks must always run
  const nav = useNavigate();
  const loc = useLocation();

  const isProd = process.env.NODE_ENV === "production";
  const isOnDebug = loc.pathname === "/debug-auth";
  // Show ONLY when explicitly enabled (keeps it hidden by default)
  const showDev = String(process.env.REACT_APP_SHOW_DEV_AUTH || "").trim() === "1";

  if (!showDev || isProd || isOnDebug) return null;

  return (
    <button
      type="button"
      onClick={() => nav("/debug-auth")}
      title="Open Debug Auth"
      style={{
        position: "fixed",
        right: 14,
        bottom: 14,
        zIndex: 9999,
        padding: "10px 12px",
        borderRadius: 999,
        border: "1px solid rgba(255,255,255,0.18)",
        background: "rgba(11,15,25,0.92)",
        color: "white",
        fontFamily: "system-ui, Arial",
        fontSize: 13,
        fontWeight: 700,
        cursor: "pointer",
        boxShadow: "0 12px 30px rgba(0,0,0,0.28)",
      }}
    >
      DEV Auth
    </button>
  );
}